import React, { Component, PropTypes } from 'react'
import { Link } from 'react-router'

import Dialog from './Dialog';
import config from 'config';
import qs from 'querystring';

import { getReportStatus } from 'common/api'
import { getUserInfo } from 'common/user'
import styles from './ReportButton.css'

class ReportButton extends Component {
  static propTypes = {
    status: PropTypes.number.isRequired,
    answerId: PropTypes.number.isRequired
  }

  constructor () {
    super()
    this.state = {
      type: 0,
      name: '',
      total: '',
      id: '',
      pigaiProductId: '',
    }

    this.handleClick = this.handleClick.bind(this)
    this.handleCloseDialog = this.handleCloseDialog.bind(this)
    this.submitPigai = this.submitPigai.bind(this)
  }

  handleClick () {
    const { answerId } = this.props;
    const token = getUserInfo().token;
    getReportStatus(answerId, token).then(data => {
      this.setState({
        type: data.type,
        name: data.name,
        total: data.total,
        id: data.id,
        pigaiProductId: data.pigaiProductId
      });
    });
  }

  handleCloseDialog () {
    this.setState({ type: 0 })
  }

  submitPigai(e) {
    const { answerId } = this.props;
    const token = getUserInfo().token;
    fetch(`${config.api.ti}/pigai/submit`,{
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: qs.stringify({
        answerId,
        token,
        srvId: this.state.id,
      })
    })
    .then(res => res.json())
    .then(json => {
      if (json.msg) {
        let errorMsg = '当前使用的人过多!请稍后再试!'
        if (typeof e === 'string' && e.indexOf('错误代码: onlinep10018') !== -1) {
          errorMsg = '该题目无法提交批改'
          this.setState({
            type: 5,
            errorMsg: (json && json.msg) || errorMsg
          })
        }
      } else {
        this.setState({
          type: 6
        })
      }
    })
  }

  renderDialog () {
    let tip, title, buttons = [];
    const { type, name, total, pigaiProductId, errorMsg } = this.state;
    const { exam } = this.props;
    switch (type) {
      case 2:
        tip = '您还未购买对应的批改类型服务!'
        title = '无法提交批改'
        buttons = [
          { text: '取消', clickFc: this.handleCloseDialog },
          {
            text: '立即购买',
            clickFc: this.handleCloseDialog,
            href:`${config.site.zhike}/${exam}/course/${pigaiProductId}.html`,
            isBuyBtn: true,
          },
        ]
        break
      case 3:
        tip = '您购买的对应批改类型服务次数已用完!'
        title = '无法提交批改'
        buttons = [
          { text: '取消', clickFc: this.handleCloseDialog },
          {
            text: '立即购买',
            clickFc: this.handleCloseDialog,
            href:`${config.site.zhike}/${exam}/course/${pigaiProductId}.html`,
            isBuyBtn: true,
          },
        ]
        break
      case 4:
        tip = (
          <span>
            <p>提交人工批改将会消耗批改余量:</p>
            <p>{`${name} x1 当前剩余 x${total}`}</p>
            <p>我们的外教将在3个工作日内交付详尽的批改结果.</p>
          </span>
        )
        title = '提交批改'
        buttons = [
          { text: '取消', clickFc: this.handleCloseDialog },
          { text: '提交批改', clickFc: this.submitPigai },
        ]
        break
      case 5:
        tip = errorMsg;
        break
      case 6:
      title = '提交成功'
      tip = (
        <span>
          <p>Well Done!</p>
          <p>专家的反馈将给你带来意想不到的收获!</p>
        </span>
      )
      buttons = [
        {text: '再练几道', clickFc: this.handleCloseDialog},
      ]
        break
      case 7:
        tip = '您正在请假中，销假后可提交批改'
        buttons = [
          { text: '取消', clickFc: this.handleCloseDialog },
          { text: '去销假', href: `${config.site.zhike}/user.html` },
        ]
        break
      default:
        tip = '网络错误，请您稍后再试'
    }
    return type > 0 && <Dialog tip={tip} buttons={buttons} title={title} type={type} closeDialog={this.handleCloseDialog} />
  }

  renderCheckReport () {
    // const statusMap = {
    //   0: '提交外教批改',
    //   1: '外教批改中...',
    //   2: '查看外交批改',
    //   3: '查看外交批改'
    // }
    const { status, answerId, exam } = this.props

    if (status === 0) {
      return (
        <span
          className={styles.button}
          onClick={this.handleClick}
        >
         提交批改
        </span>
      )
    } else if (status === 2 || status === 3) {
      return (
        <span className={styles.button}>
          <Link to={ `${config.site.zhike}/${exam}/manualReport.html?answerId=${answerId}` }>批改报告</Link>
        </span>
      )
    } else if (status === 1) {
      return (
        <span className={styles.button}>
          批改中
        </span>
      )
    }
  }

  render () {
    return (
      <span className={styles.report}>
        { this.renderCheckReport() || false }
        { this.renderDialog() }
      </span>
    )
  }
}


export default ReportButton



/** WEBPACK FOOTER **
 ** ./src/components/QuestionList/ReportButton.js
 **/